const accordions = document.querySelectorAll(".jsAccordionItem") as NodeListOf<HTMLElement>;

const getElemDistance = (elem) => {
    let location = 0;
    if (elem.offsetParent) {
        do {
            location += elem.offsetTop;
            elem = elem.offsetParent;
        } while (elem);
    }
    return location;
};
 
const openAccordion = (accordion, content) => {
    accordion.classList.add("accordion--active");
    content.style.maxHeight = content.scrollHeight + "px";
};
 
const closeAccordion = (accordion, content) => {
    accordion.classList.remove("accordion--active");
    content.style.maxHeight = null;
};
 
accordions.forEach(accordion => {
    const intro = <HTMLElement>accordion.querySelector(".jsAccordionTitle");
    const content = <HTMLElement>accordion.querySelector(".jsAccordionContent");
 
    intro!.onclick = () => {
        if (content!.style.maxHeight) {
            closeAccordion(accordion, content);
        } else {
            accordions.forEach((accordion) => closeAccordion(accordion, accordion.querySelector(".jsAccordionContent")));
            openAccordion(accordion, content);
        }
    };
});
